<template>
  <div class="edit-merchant">
    <div class="profile">
      <div class="profile__left">
        <div class="profile__title">Merchant Details</div>
        <div class="profile__caption">
          Be sure to enter the right merchant details
        </div>
      </div>
      <div class="profile__right">
        <div class="form__flex">
          <div class="form__flex__item">
            <label class="form__label" for>Full Name</label>
            <input
              class="form__input"
              type="text"
              v-model.trim="$v.fullName.$model"
            />
            <span class="attention" v-if="$v.fullName.$error"
              >Field can't be empty</span
            >
          </div>
          <div class="form__flex__item">
            <label class="form__label" for>Phone Number</label>
            <input
              @keydown="preventKeys"
              class="form__input"
              maxlength="11"
              type="text"
              v-model.trim="$v.mobileNumber.$model"
            />
            <span class="attention" v-if="$v.mobileNumber.$error"
              >Field can't be empty</span
            >
          </div>
        </div>
        <div class="form__flex">
          <div class="form__flex__item">
            <label class="form__label" for>Business Name</label>
            <input
              class="form__input"
              type="email"
              v-model.trim="$v.businessName.$model"
            />
            <span class="attention" v-if="$v.businessName.$error"
              >Field can't be empty</span
            >
          </div>
          <div class="form__flex__item">
            <label class="form__label" for>Business NUBAN</label>
            <input
              @keydown="preventKeys"
              class="form__input"
              maxlength="10"
              type="text"
              v-model.trim="$v.businessNuban.$model"
            />
            <span class="attention" v-if="$v.businessNuban.$error"
              >Field can't be empty</span
            >
          </div>
        </div>
        <div class="form__item">
          <label class="form__label" for>Email</label>
          <input
            autocomplete="off"
            class="form__input"
            type="email"
            v-model.trim="$v.emailAddress.$model"
          />
          <span class="attention" v-if="$v.emailAddress.$error"
            >Field can't be empty</span
          >
        </div>
      </div>
    </div>
    <div class="action">
      <button
        :disabled="disabled"
        @click="editMerchant"
        class="btn btn--primary"
      >
        Save Changes
      </button>
    </div>
    <div
      class="profile border-divider"
      v-if="settlementTypes && settlementTypes.length && !isNaN(settlementTime)"
    >
      <div class="profile__left">
        <div class="profile__title">Settlement Setup</div>
      </div>
      <div class="profile__right">
        <div class="space-down">
          <Dropdown
            style="width: 100%"
            title="Settlement Types"
            :label="
              settlementTypes[allowRealTimeSettlement ? 2 :
              settlementTime].value || 'Select Settlement Type'
            "
            :options="settlementTypes.length > 0 ? settlementTypes : []"
            :onOptionSelected="
              ({ id }) => (selected_settlement.settlement_id = id)
            "
          />
        </div>
      </div>
    </div>
    <Loader v-else />
    <div class="action border-divider-button">
      <button
        :disabled="disabled_settlement_button"
        @click="handleSaveSettlementType"
        class="btn btn--primary"
      >
        Save Changes
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Dropdown from "@/components/dropdown";
import { required } from "vuelidate/lib/validators";
import Loader from "../../../../components/loader";
export default {
  metaInfo: {
    title: "Edit Merchant",
  },
  components: {
    Loader,
    Dropdown,
  },
  data() {
    return {
      fullName: "",
      businessName: "",
      mobileNumber: "",
      businessNuban: "",
      password: "",
      emailAddress: "",
      merchantID: "",
      settlementTypes: [],
      selected_settlement: {
        settlement_id: "",
      },
      settlementTime: "",
      disabled: false,
      disabled_settlement_button: false,
      allowRealTimeSettlement: 0
    };
  },

  created() {
    this.fetchMerchants();
    this.fetchSettlements();
  },

  validations: {
    fullName: {
      required,
    },
    businessName: {
      required,
    },
    mobileNumber: {
      required,
    },
    businessNuban: {
      required,
    },
    emailAddress: {
      required,
    },
  },

  methods: {
    resetState() {
      this.$v.$reset();
    },

    loadEdit(value) {
      // load data
      this.fullName = value.fullname;
      this.businessName = value.business_name;
      this.mobileNumber = value.mobile_number;
      this.businessNuban = value.business_nuban;
      this.emailAddress = value.email;
      this.merchantID = value.id;
      this.settlementTime = value.settlement_time;
      this.allowRealTimeSettlement = value.allow_real_time_settlement
    },

    fetchMerchants() {
      this.$http
        .get(`admin/merchants?merchantId=${this.$route.params.id}`)
        .then((response) => {
          if (response.body.data.merchants.length > 0) {
            this.loadEdit(response.body.data.merchants[0]);
            // this.emptyState = false;
            // this.loading = false;
          } else {
            // this.emptyState = true;
            // this.loading = false;
          }
        })
        .catch((error) => {
          // LOG Error
        });
    },
    fetchSettlements() {
      this.$http.get(`dashboard/admin/merchants/settlements/types`).then(
        (response) => {
          let merchant;
          merchant = Object.values(response.body.data).map(
            ({ settlement_type_id, settlement_type }) => ({
              id: settlement_type_id,
              value: settlement_type,
            })
          );

          this.settlementTypes = merchant;
        },
        () => {}
      );
    },
    editMerchant(value) {
      // Make sure none of the compulsory field are not empty or invalid
      if (!this.$v.$invalid) {
        // Disable button
        this.disabled = true;
        // Generate Default Request
        let requestObject = {
          id: this.merchantID,
        };

        // Check for values that have changed ( that has been modified)
        if (this.$v.fullName.$dirty) {
          if (!this.$v.fullName.$error) {
            requestObject.fullname = this.fullName;
          } else {
            return;
          }
        }
        if (this.$v.businessName.$dirty) {
          if (!this.$v.businessName.$error) {
            requestObject.business_name = this.businessName;
          } else {
            return;
          }
        }
        if (this.$v.businessNuban.$dirty) {
          if (!this.$v.businessNuban.$error) {
            requestObject.business_nuban = this.businessNuban;
          } else {
            return;
          }
        }

        if (this.$v.mobileNumber.$dirty) {
          if (!this.$v.mobileNumber.$error) {
            requestObject.mobile_number = this.mobileNumber;
          } else {
            return;
          }
        }

        if (this.$v.emailAddress.$dirty) {
          if (!this.$v.emailAddress.$error) {
            requestObject.email = this.emailAddress;
          } else {
            return;
          }
        }

        // Procceed to update
        this.$http
          .put("admin/merchants", requestObject)
          .then((response) => {
            this.disabled = false;
            this.$notify({
              group: "notifications-default",
              type: "success text-white",
              title: "Success",
              text: response.body.message,
            });
            this.resetState();
            this.fetchMerchants();
          })
          .catch((error) => {
            this.disabled = false;
            this.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text: error.body.message,
            });
          });
      }
    },
    handleSaveSettlementType() {
      // Make Save Button Disabled
      this.disabled_settlement_button = true;

      let requestObject = {
        settlement_type_id: this.selected_settlement.settlement_id,
      };

      // Updated Merchants Settlement Type
      this.$http
        .put(
          `dashboard/admin/merchants/settlements/${this.merchantID}`,
          requestObject
        )
        .then(
          (response) => {
            // Make Save Button Not Disabled
            this.disabled_settlement_button = false;

            this.$notify({
              group: "notifications-default",
              type: "success text-white",
              title: "Success",
              text: response.body.data.message,
            });
          },
          (error) => {
            // Make Save Button Not Disabled
            this.disabled_settlement_button = false;
            this.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text: error.body.message,
            });
          }
        );
    },
  },
};
</script>
<style lang="scss" scoped>
.nuban {
  padding: 100px 25px 120px;
  text-align: center;

  &__number {
    color: #e8368f;
    font-size: 32px;
    line-height: 35px;
    padding: 19px 28px 15px;
    background-color: rgba(#e8368f, 0.15);
    border-radius: 16px;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 32px;
    position: relative;
  }

  &__title {
    color: #261940;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 16px;
  }

  &__caption {
    color: rgba(#261940, 0.8);
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 32px;
  }

  &__copy {
    position: absolute;
    color: #e00b5b;
    font-size: 12px;
    line-height: 13px;
    top: -20px;
    right: 0;
    cursor: pointer;
  }
}

.space-down {
  margin-bottom: 32px;
}
.border-divider {
  border-top: 4px solid #ebf0f4;
}

.border-divider-button {
  border-top: 1px solid #ebf0f4;
}

.profile {
  border-bottom: none !important;
}

.action {
  padding: 30px 98px 30px 0;
  text-align: right;
}
</style>
